module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Richard Howard is the pseudonym of a bestselling British author who usually works in another genre. However, his love of the Napoleonic Wars, his life long interest in military history and particularly, the material offered by the campaigns of Napoleon drove him to write the series of novels featuring Alain Lausard and the men who fight alongside him.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uUAjDn/tc-custom/9781788632003.jpg?1705201994972",
      "alt": "This image is the cover for the book Bonaparte's Avengers, The Alain Lausard Adventures"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bonaparte's Avengers, The Alain Lausard Adventures\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("As Napoleon prepares to invade Prussia, a war-weary sergeant is pushed to his limit in this epic military adventure series.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("France, 1806")]), _vm._v(". Napoleon Bonaparte’s Grande Armeé is poised for war. But this is no ordinary mission. Having crushed the forces of Austria and Russia the year before, Bonaparte now seeks to avenge the French Army’s annihilation by Frederick the Great’s Prussian forces in 1757. When Prussia refuses to comply with Bonaparte’s demands that they surrender and form an alliance against England, war becomes inevitable."), _c('br'), _vm._v(" Sergeant Alain Lausard and his war-weary squadron of dragoons have been through many epic battles under Napoleon’s command. They would do anything for their great leader. But as they prepare to enter into yet another bloody campaign that will feature battles at Jena and Auerstadt, their loyalties are stretched to the limit . . . ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0